export enum FormStage {
    STUDENT = "STUDENT",
    SCHOOL = "SCHOOL",
    GUARDIAN = "GUARDIAN",
    BOOKING = "BOOKING",
    CONFIRMATION = "CONFIRMATION",
    PAYMENT = "PAYMENT",
}
